import MUIDataTable from 'mui-datatables';
import React from 'react'
import { useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import Toggle from 'react-toggle';
import { getColorList,updateColor, DeleteCarColor } from '../../../actions/homeAction';

const CarModel = () => {

	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(getColorList())
	},[])

	const handleStatusChange = (Id,active)=>{
		var data ={
			colorId: Id,
			active : !active
		}
		dispatch(updateColor(data))
	}
	const HandleDelete = ( ID )=>{
		if(ID){
		dispatch(DeleteCarColor(ID))
		}
	}

	const colorList = useSelector(state => state.home.colorList)?.response

	console.log("colorList", colorList);
  const carModelList = []
  let columns = [];

		columns = [
			{
				name: 'color',
				label: 'Color Name',
				options: {
					filter: false,
					sort: true,
				},
			},
			{
				name: 'colorAr',
				label: 'Color Name Ar',
				options: {
					filter: false,
					sort: true,
				},
			},

			{
				name: 'priority',
				label: 'Priority',
				options: {
					filter: false,
					sort: true,
				},
			},

			{
				name: 'active',
				label: 'Status',
				options: {
					filter: true,
					sort: true,
					customBodyRender: (active, tableMeta) => {
						var Id = tableMeta.rowData[2];
						// console.log(tableMeta.rowData[6]);
						return (
							<Toggle
								id={'status_' + Id}
								defaultChecked={active}
								value={active}
								onChange={()=>handleStatusChange(Id, active)}
							/>
						);
					},
				},
			},
			{
				name: 'colorId',
				label: 'Action',
				options: {
					filter: true,
					sort: true,
					customBodyRender: (colorId) => {
						return (
							<div>
								<Link to={`/CarDetail/Color/Update/${colorId}?`}><FaEdit style={{fontSize: '1.4rem'}} /></Link>
								<span className='delBTN' onClick={()=>HandleDelete(colorId)}><MdOutlineDeleteOutline style={{fontSize: '1.4rem', marginLeft:"1rem"}} /></span>
							</div>
						);
					},
				},
			},

		];
    
		const options = {
			filter: false,
			viewColumns: false,
			print: false,
			download: false,
			selectableRows: 'none',
			textLabels: {
				body: {
					// noMatch: this.state.isSaving
					// 	? 'Loading data..!'
					// 	: 'Sorry, No Users Found',
					toolTip: 'Sort',
					columnHeaderTooltip: column => `Sort for ${column.label}`,
				},
			},
		};
  return (
    <div className='pcoded-inner-content'>
				<div className='main-body'>
					<div className='page-wrapper'>
						<div className='row'>
							<div className='col-sm-12'>
								<div className='card'>
									<div className='card-header'>
										<Link
											to={`/CarDetail/Color/Add`}
											className='btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger'
											data-modal='modal-13'>
											{' '}
											<i className='icofont icofont-plus m-r-5'></i>
											Add Color
										</Link>
									</div>

									<div className='card-block'>
										<div className='dt-responsive table-responsive'>
											{carModelList !== undefined ? (
												<MUIDataTable
													title={`Color`}
													className='table-responsive'
													data={colorList}
													columns={columns}
													options={options}
												/>
											) : (
												<h4>Loading...</h4>
											)}
											{/* </MuiThemeProvider> */}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
  )
}

export default CarModel